import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const Grid3x3Icon = createIcon({
  displayName: 'Grid3x3Icon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g xmlns="http://www.w3.org/2000/svg" fill="none">
        <path d="M0 0h24v24h-24Z" />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M5 14v0c-1.105 0-2-.895-2-2v0c0-1.105.895-2 2-2v0c1.105 0 2 .895 2 2v0c0 1.105-.895 2-2 2Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12 14v0c-1.105 0-2-.895-2-2v0c0-1.105.895-2 2-2v0c1.105 0 2 .895 2 2v0c0 1.105-.895 2-2 2Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M19 14v0c-1.105 0-2-.895-2-2v0c0-1.105.895-2 2-2v0c1.105 0 2 .895 2 2v0c0 1.105-.895 2-2 2Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M5 21v0c-1.105 0-2-.895-2-2v0c0-1.105.895-2 2-2v0c1.105 0 2 .895 2 2v0c0 1.105-.895 2-2 2Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12 21v0c-1.105 0-2-.895-2-2v0c0-1.105.895-2 2-2v0c1.105 0 2 .895 2 2v0c0 1.105-.895 2-2 2Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M19 21v0c-1.105 0-2-.895-2-2v0c0-1.105.895-2 2-2v0c1.105 0 2 .895 2 2v0c0 1.105-.895 2-2 2Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M5 7v0c-1.105 0-2-.895-2-2v0c0-1.105.895-2 2-2v0c1.105 0 2 .895 2 2v0c0 1.105-.895 2-2 2Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12 7v0c-1.105 0-2-.895-2-2v0c0-1.105.895-2 2-2v0c1.105 0 2 .895 2 2v0c0 1.105-.895 2-2 2Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M19 7v0c-1.105 0-2-.895-2-2v0c0-1.105.895-2 2-2v0c1.105 0 2 .895 2 2v0c0 1.105-.895 2-2 2Z"
        />
      </g>
    </>
  ),
})

const Grid3x3: FC<IconProps> = (props) => {
  return <CustomIcon as={Grid3x3Icon} {...props} />
}

export default memo(Grid3x3)
